module.exports = __webpack_public_path__ + "img/collection-diamondJewelryGold.0b93050.webp";